var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupBk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#d7def1;}.cls-3{fill:#3d55a5;}.cls-4{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.07,
    y: 31.07,
    width: 187.87,
    height: 187.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_BK",
    "data-name": "Group BK"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.14,72.13V194.76L87.59,166H185a16.89,16.89,0,0,0,16.89-16.88v-77A16.89,16.89,0,0,0,185,55.24H65A16.89,16.89,0,0,0,48.14,72.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.53,77.56v117.2l-32.17-28.71H70.55a8.38,8.38,0,0,1-8.37-8.38V77.56a8.38,8.38,0,0,1,8.37-8.38H179.16A8.38,8.38,0,0,1,187.53,77.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 145.11,
    cy: 115.16,
    r: 10.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.76,143.81v-8.47a23.61,23.61,0,0,0-35.3,0v8.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 110.7,
    cy: 105.26,
    r: 14.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.44,143.81v-11.4a31.76,31.76,0,0,0-47.49,0v11.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupBk);
export default __webpack_public_path__ + "static/media/group_bk.b5cb0eb36a5fba5a0d1ad5663b66f4b3.svg";
export { ForwardRef as ReactComponent };